import React, { useState, useEffect } from "react";
import { render } from "react-dom";
import Highcharts from "highcharts";
import HC_exporting from "highcharts/modules/exporting";
import HighchartsReact from "highcharts-react-official";
import { fetchJson } from "../../../lib/Fetching";
import moment from "moment";
import { paramsDate } from "../../../lib/DateFormatting";
import { Loading, GraphContainer } from "./Theme";
import styled from "styled-components";
import Link from "../../Link";

HC_exporting(Highcharts);

const Close = styled.span`
  cursor: pointer;
  padding-left: 10px;
  top: 15px;
  left: 15px;
  position: relative;
  z-index: 999;
`;
const CloseLink = ({ onClick }) => (
  <Close onClick={onClick}>
    <i className="fa fa-times" />
  </Close>
);

const GraphLink = styled(Link)`
  margin-right: 20px;
  color: #60c2a9;
`;

const distinct = (value, index, self) => {
  return self.indexOf(value) === index;
};

export default function MyGraph({ chart, findSamples, removeChart }) {
  console.log(chart);
  const [results, setResults] = useState(null);
  const [options, setOptions] = useState(null);
  const [failedSampleIds, setFailedSampleIds] = useState([]);

  useEffect(
    () => {
      setOptions(null);
      fetchJson("/sample_reporting/trending/graph", {
        form: {
          product_ids: chart.product_ids,
          test_name_ids: chart.test_name_ids,
          start_date: paramsDate(chart.start_date),
          end_date: paramsDate(chart.end_date),
          data_fields: chart.data_fields || []
        }
      }).then(container => {
        setFailedSampleIds(container.failed_results.map(r => r.sample_id).filter(distinct));
        setOptions(createOptions({ chart, container, findSamples }));
      });
    },
    [chart]
  );

  const viewFailedSamples = () => {
    findSamples({ sample_ids: failedSampleIds });
  };

  return (
    <GraphContainer>
      {options ? (
        <div>
          <div>
            {removeChart && <GraphLink onClick={() => removeChart(chart)}>Close</GraphLink>}
            {failedSampleIds.length > 0 &&
              findSamples && (
                <GraphLink onClick={viewFailedSamples}>
                  View {failedSampleIds.length} Failed Samples
                </GraphLink>
              )}
          </div>
          <HighchartsReact highcharts={Highcharts} options={options} />
        </div>
      ) : (
        <Loading>
          Loading data for '{chart.full_description}
          `. Please wait...
        </Loading>
      )}
    </GraphContainer>
  );
}

const createOptions = ({ chart, container, findSamples }) => ({
  exporting: {
    enabled: true
  },
  chart: {
    boost: {
      enabled: false
    },
    height: 300,
    zoomType: "x"
  },
  xAxis: {
    type: "datetime"
  },

  title: {
    text: chart ? chart.full_description : "",
    style: {
      fontFamily: "Source Sans Pro",
      fontSize: "12pt",
      textTransform: "uppercase"
    }
  },

  subtitle: {
    text: chart.subtitle
  },

  tooltip: {
    style: {
      width: "250px"
    }
  },

  yAxis: [
    {
      labels: {
        enabled: true
      },
      title: {
        text: null
      }
    }
  ],

  plotOptions: {
    flags: {
      tooltip: {
        xDateFormat: "%B %e, %Y"
      }
    },
    scatter: {
      marker: {
        radius: 2,
        states: {
          hover: {
            enabled: true
          }
        }
      },
      states: {
        hover: {
          marker: {
            enabled: false
          }
        }
      },
      cursor: "pointer",
      point: {
        events: {
          click:
            findSamples &&
            function() {
              findSamples({ sample_ids: [this.options.sample_id] });
            }
        }
      }
    }
  },

  series: [
    {
      color: "#FF0000",
      turboThreshold: 0,
      zIndex: 100,
      yAxis: 0,
      name: "Failed Results",
      id: "results",
      type: "scatter",
      marker: {
        radius: 3
      },
      tooltip: {
        headerFormat: '<span style="font-size: 11px;color:#F66">FAILED POINT</span><br>',
        pointFormat: "<br><b>{point.f}</b>"
      },
      data: container.failed_results.map(r => ({
        ...r,
        x: moment
          .utc(r.x)
          .local()
          .toDate()
      }))
    },
    {
      color: "#4444FF",
      turboThreshold: 0,
      zIndex: 50,
      yAxis: 0,
      name: "Passed Results",
      id: "results",
      type: "scatter",
      tooltip: {
        headerFormat:
          '<span style="font-size: 11px;color:#666">{point.x:%B %e, %Y}</span><br>',
        pointFormat: "<br><b>{point.f}</b>"
      },
      data: container.results.map(r => ({
        ...r,
        x: moment
          .utc(r.x)
          .local()
          .toDate()
      }))
    }
  ]
});
